module.exports = __webpack_public_path__ + "img/pauli-x-root-dagger-30.8d3ea19f.svg";